import {ResultTypesEnum} from '../../settings/editors/expressions/infer/expressionResultModel';
import {ClientAtom, Expression} from '../../settings/editors/expressions/iotsCodecs';

function atomHasError(atom: ClientAtom) {
  if (atom.dryRun?.type === ResultTypesEnum.UNDEFINED) {
    return true;
  }

  if (!atom.functionAtoms) {
    return false;
  }

  return atom.functionAtoms.some(({dryRun}) => dryRun?.type === ResultTypesEnum.UNDEFINED);
}

export function expressionHasDryRunError(expression: Expression) {
  if (!expression.dryRun) {
    return false;
  }

  if (expression.dryRun.type === ResultTypesEnum.UNDEFINED) {
    return true;
  }

  return expression.atoms.some(atomHasError);
}
